import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=bcdaf45a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=bcdaf45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdaf45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcdaf45a')) {
      api.createRecord('bcdaf45a', component.options)
    } else {
      api.reload('bcdaf45a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=bcdaf45a&scoped=true&", function () {
      api.rerender('bcdaf45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UuS2KR37x3xe/JS/comp/DateRangeExt.vue"
export default component.exports